type Primitive = string | number | boolean;

export const objectToQueryString = (object: Record<string, Primitive>) =>
  Object.keys(object)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
